module.exports = __webpack_public_path__ + "assets/closeDialogButton-5b4d16.svg";